import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionButton = ({ 
  label, 
  icon, 
  iconColor = 'var(--color-primary)',
  description,
  onClick 
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' || e?.key === ' ') {
      e?.preventDefault();
      onClick();
    }
  };

  return (
    <button
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className="bg-card rounded-lg p-4 md:p-5 border border-border shadow-elevation-1 hover:shadow-elevation-2 transition-smooth hover:-translate-y-1 active:scale-[0.97] text-left w-full"
    >
      <div className="flex items-start space-x-3 md:space-x-4">
        <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name={icon} size={20} color={iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm md:text-base font-semibold text-foreground mb-1">
            {label}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>
        <Icon name="ChevronRight" size={20} className="flex-shrink-0 text-muted-foreground" />
      </div>
    </button>
  );
};

export default QuickActionButton;